import { render, staticRenderFns } from "./TransferOTPAuth.vue?vue&type=template&id=533e7c48&scoped=true"
import script from "./TransferOTPAuth.vue?vue&type=script&lang=js"
export * from "./TransferOTPAuth.vue?vue&type=script&lang=js"
import style0 from "./TransferOTPAuth.vue?vue&type=style&index=0&id=533e7c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e7c48",
  null
  
)

export default component.exports